$(function () {
    // 活动倒计时
    function countTime() {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();

        //设置截止时间
        var str="2019/4/25 13:00:00";
        var endDate = new Date(str);
        var end = endDate.getTime();

        //时间差
        var leftTime = end-now;

        //定义变量 d,h,m,s保存倒计时的时间
        var d,h,m,s;
        if (leftTime>=0) {
             d = Math.floor(leftTime/1000/60/60/24);
             h = Math.floor(leftTime/1000/60/60%24);
             m = Math.floor(leftTime/1000/60%60);
             s = Math.floor(leftTime/1000%60);
         }else {
            d = "00";
            h = "00";
            m = "00";
            s = "00";
        }

        //将倒计时赋值到div中
        if ((d*24)+h > 0){
            document.getElementsByClassName("lv1-time-hours")[0].innerHTML = (d*24)+h;
        } else {
            document.getElementsByClassName("lv1-time-hours")[0].innerHTML = "00";
        }
        if (m > 0){
            document.getElementsByClassName("lv1-time-minutes")[0].innerHTML = m;
        } else {
            document.getElementsByClassName("lv1-time-minutes")[0].innerHTML = "00";
        }
        document.getElementsByClassName("lv1-time-seconds")[0].innerHTML = s;


         //递归每秒调用countTime方法，显示动态时间效果
         setTimeout(countTime,1000);

    }
    countTime();


    $(".lv1-tab1 a, .lv1-tab3 a").click(function () {
        $(".hint-window").fadeIn("fast", function () {
            $(".hint-window-text").html("精彩敬请期待！请先参与预约活动吧。")
        })
    });

    $(".hint-close-btn").click(function () {
        $(".lv1-tab2 input").removeAttr('disabled');
        $(".hint-window-text").html("");
        $(".hint-window").hide();
    });

    var auth = ycgame.auth;

    // 登录
    $(".header-login-btn, .lv1-tab2 input").click(function (e) {
        if (! auth.member) {
            $.ycUserDialogOpen();
            e.stopImmediatePropagation();
        }
    });

    auth.bind( auth.EVENTS.LOGOUT, function () {
        location.reload();
    });

    auth.checkLogin();

    auth.bind( auth.EVENTS.LOGIN, function () {
        role();
        $(".header-login-btn").hide().siblings(".login").show();

        $(".lv1-tab2 input").attr('disabled', true).click(function () {
            $(this).attr('disabled', true);
            var indexId = $(this).index() + 1;
            role(indexId);
        });
    });

    // 初始化获取用户信息
    function role(indexId) {
        var userDataUrl = 'http://act-api.bos.ycgame.com/order-mulan-hero/players';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".login-username i").html(data.account);
            $(".lv1-tab2 input").removeAttr('disabled');
            if (data.cdkey.length != 0){
                $(".open-cdk p").html(data.cdkey);
                $(".lv1-tab2 input").addClass('active');
            }

            if (indexId && data.cdkey.length != 0){
                openCdk();
            } else if (indexId && data.cdkey.length == 0) {
                exchangeCDK();
            }


        }).fail(function (xhr) {
            if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始，将于4月15日上午开启！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            }
            setTimeout(function () {
                $(".login-out").click();
            },2000);
        })
    }



    // 兑换奖励
    function exchangeCDK() {
        var url = "http://act-api.bos.ycgame.com/order-mulan-hero/comeback/exchange";
        $.ajax({
            type: "POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".lv1-tab2 input").removeAttr('disabled');
            $(".open-cdk p").html(data.code);
            openReservation();
        }).fail(function (xhr) {
            $(".lv2-tab li input").removeAttr('disabled');
            if (xhr.status == 403 && xhr.responseJSON.code == "null") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("激活码不足,无法领取！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("该激活码已经领取过了！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "服务器繁忙，请稍后再试！") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("服务器繁忙，请稍后再试！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            }
        })
    }



    // openReservation
    var $openReservation;
    $openReservation = $('.open-reservation');
    $openReservation.on('click', '.reservation-close-btn', function () {
        closeReservation();
        openCdk();
    });

    function openReservation(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $openReservation, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });

        $openReservation.data('layer', layerId);
        $openReservation.find('.' + id).show().siblings().hide();

        cb && cb.call($openReservation);
    }

    function closeReservation() {
        layer.close($openReservation.data('layer'));
    }

    // openCdk
    var $openCdk;
    $openCdk = $('.open-cdk');
    $openCdk.on('click', '.cdk-close-btn', function () {
        $('.open-cdk p').html("");
        $(".lv1-tab2 input").addClass('active');
        closeCdk();


    });

    function openCdk(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $openCdk, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });

        $openCdk.data('layer', layerId);
        $openCdk.find('.' + id).show().siblings().hide();

        cb && cb.call($openCdk);
    }

    function closeCdk() {
        layer.close($openCdk.data('layer'));
    }

});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0